var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var TinyDatePicker = require('tiny-date-picker');

function SelectField(el) {
	var t = this;
	t.el = el;
	t.$el = $(el);
	t.fieldMobile = t.el.querySelector('[data-field-mobile]');
	t.fieldDesktop = t.el.querySelector('[data-field-desktop]');
	t.fieldCurrent = t.el.querySelector('[data-field-current]');

	t.onClickActive = function () {
		if (!t.isActive()) {
			var data = t.fieldMobile.value;
			var activeItem = $(t.fieldDesktop).find('[data-value="' + data + '"]');
			$(t.fieldDesktop).find('.select-field__dropdown-item').removeClass('active').removeAttr('id');
			activeItem.addClass('active').attr('id', 'selected-option');
		}

		t.el.classList.toggle('select-field--active');
	};

	t.onSelectDesktop = function (e) {
		if (e.keyCode === 13 || !e.keyCode) {
			var data = this.getAttribute('data-value');
			t.removeSelectActive();
			this.classList.add('active');
			this.setAttribute('id','selected-option');
			t.fieldCurrent.innerHTML = this.innerHTML;
			t.fieldMobile.value = data;
			if (t.callback) {
				t.callback(t.fieldMobile.value);
			}
			t.el.classList.remove('select-field--active');
		}
	};

	t.onSelectMobile = function () {
		var data = this.value,
			currentItem = t.fieldMobile.querySelector('[value="' + data + '"]');
		t.fieldCurrent.innerHTML = currentItem.innerHTML;
		t.removeSelectActive();
		t.fieldDesktop.querySelector('[data-value="' + data + '"]').classList.add('active');
		if (t.callback) {
			t.callback(t.fieldMobile.value);
		}
	};

	t.onClickOutside = function (e) {
		if (!e.target.hasAttribute('data-field-current') && e.target != t.fieldMobile || e.target != t.fieldCurrent && e.target != t.fieldMobile) {
			t.el.classList.remove('select-field--active');
		}
	};

	t.keyboardHandlers = function (e) {
		var key = e.which || e.keyCode,
			activeItem, $activeItem, $prevItem, $nextItem, $dropdown, index, add;

		switch (key) {
			case (32 || 13):  // space
				if (!t.isActive()) {
					t.onClickActive();
				} else {
					activeItem = t.fieldDesktop.querySelector('.select-field__dropdown-item.active');
					t.onSelectDesktop.apply(activeItem);
				}

				e.preventDefault();

				break;
			case 27:  // escape
				if (t.isActive()) {
					t.onClickActive();
					e.preventDefault();
				}

				break;
			case 38:  // up
				if (!t.isActive()) {
					t.onClickActive();
				} else {
					$activeItem = t.$el.find('.select-field__dropdown-item.active');
					$prevItem = $activeItem.prev();

					if ($prevItem.length) {
						$activeItem.removeClass('active').removeAttr('id');
						$prevItem.addClass('active').attr('id', 'selected-option');

							$dropdown = t.$el.find('.select-field__dropdown');
						index = t.$el.find('.select-field__dropdown-item').index($prevItem);
						add = ($prevItem.outerHeight(true) - $prevItem.outerHeight()) / 2 * index;

						if ($dropdown.scrollTop() > $prevItem.position().top + add) {
							$dropdown.scrollTop($prevItem.position().top + add);
						}
					}
				}

				e.preventDefault();
				break;
			case (40):  // down
				if (!t.isActive()) {
					t.onClickActive();
				} else {
					$activeItem = t.$el.find('.select-field__dropdown-item.active');
					$nextItem = $activeItem.next();

					if ($nextItem.length) {
						$activeItem.removeClass('active').removeAttr('id');
						$nextItem.addClass('active').attr('id', 'selected-option');

						$dropdown = t.$el.find('.select-field__dropdown');
						index = t.$el.find('.select-field__dropdown-item').index($nextItem);
						add = ($nextItem.outerHeight(true) - $nextItem.outerHeight()) * index;

						if ($dropdown.height() < $nextItem.position().top + $nextItem.outerHeight(true) + add) {
							$dropdown.scrollTop($nextItem.position().top + $nextItem.outerHeight(true) + add - $dropdown.outerHeight(true));
						}
					}
				}

				e.preventDefault();
				break;
			case 13:  // enter
				if (t.isActive()) {
					activeItem = t.fieldDesktop.querySelector('.select-field__dropdown-item.active');
					t.onSelectDesktop.apply(activeItem);
					e.preventDefault();
				}

				break;
		}
	};

	if (t.fieldMobile && t.fieldDesktop && t.fieldCurrent) {
		t.dropdownItems = Array.prototype.slice.call(t.fieldDesktop.querySelectorAll('li'));
		// If not placeholder then select first item
		if (t.fieldCurrent.innerHTML === '') {
			t.selectFirstItem();
		}

		// Add active state to field group
		t.activeState();

		// Close Drop down when click outside
		t.clickOutside();

		// If select on desktop
		t.selectDesktop();

		// If select on mobile
		t.selectMobile();

		// Keyboard accessibility
		t.keyboardAccessible();
	}
}

SelectField.prototype.getName = function() {
	return this.fieldMobile.name;
};

SelectField.prototype.selectFirstItem = function() {
	var t = this,
		selectedItem = t.fieldDesktop.querySelector('li:first-child');

	if (t.fieldMobile.value) {
		selectedItem = t.fieldDesktop.querySelector('li[data-value="' + t.fieldMobile.value + '"]');
	} else if (selectedItem) {
		t.fieldMobile.value = selectedItem.getAttribute('data-value');
	}

	if (selectedItem) {
		t.fieldCurrent.innerHTML = selectedItem.innerHTML;
	}
};

SelectField.prototype.activeState = function() {
	var t = this;
	t.fieldCurrent.addEventListener('click', t.onClickActive);
};

SelectField.prototype.selectDesktop = function() {
	var t = this;
	t.$el.on('click keydown', '.select-field__dropdown-item', t.onSelectDesktop);
};

SelectField.prototype.selectMobile = function() {
	var t = this;
	t.fieldMobile.addEventListener('change', t.onSelectMobile);
};

SelectField.prototype.removeSelectActive = function() {
	var t = this;
	t.dropdownItems.forEach(function (otherItem) {
		otherItem.classList.remove('active');
		otherItem.removeAttribute('id');
	});
};

SelectField.prototype.clickOutside = function() {
	var t = this;
	document.addEventListener('click', t.onClickOutside);
};

SelectField.prototype.onChange = function(callback) {
	this.callback = callback;
};

SelectField.prototype.isActive = function() {
	return this.$el.hasClass('select-field--active');
};

SelectField.prototype.keyboardAccessible = function() {
	this.fieldCurrent.addEventListener('keydown', this.keyboardHandlers);
};

SelectField.prototype.destroy = function () {
	var t = this;
	t.fieldCurrent.removeEventListener('click', t.onClickActive);
	t.$el.off('click', '.select-field__dropdown-item', t.onSelectDesktop);
	t.fieldMobile.removeEventListener('change', t.onSelectMobile);
	document.removeEventListener('click', t.onClickOutside);

	t.el = null;
	t.$el = null;
	t.fieldMobile = null;
	t.fieldDesktop = null;
	t.fieldCurrent = null;
	t.callback = null;
	t.dropdownItems = null;
};

module.exports = SelectField;
